"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PipelineType = exports.ProcessInOrOut = void 0;
var ProcessInOrOut;
(function (ProcessInOrOut) {
    ProcessInOrOut["In"] = "inPro";
    ProcessInOrOut["Out"] = "outPro";
})(ProcessInOrOut || (exports.ProcessInOrOut = ProcessInOrOut = {}));
var PipelineType;
(function (PipelineType) {
    PipelineType["nfCore"] = "NF-Core";
    PipelineType["nextFlow"] = "Nextflow";
    PipelineType["ViaFoundry"] = "ViaFoundry";
})(PipelineType || (exports.PipelineType = PipelineType = {}));
